<template>
    <div class="row">
        <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous">
        <div class="col-lg-12 d-flex align-items-unset mt-0 pt-0 ml-4 buttons-users">
            <div class="buttons">
                <a 
                    href="#"
                    class="create"
                    @click="save()">
                    {{created ? 'Uložiť' : 'Vytvoriť uživateľa'}} 
                </a>
                <a 
                    href="#"
                    class="cancel"
                    v-if="created"
                    @click="cancel()">
                    Ukončiť
                </a>
            </div>

            <div v-if="created" class="form">
                <span v-show="error" class="text-danger">
                    {{error}}
                </span>
                <div class="form-floating">
                    <input v-model="user.email" type="email" class="form-control" id="floatingInput" placeholder="Email">
                    <label for="floatingInput">Email</label>
                </div>
                <div class="form-floating mt-3">
                    <input v-model="user.password" type="password" class="form-control" id="floatingPassword" placeholder="Heslo">
                    <label for="floatingPassword">Nové heslo</label>
                </div>
                <div class=" mt-3">
                    <select v-model="user.status" class="form-select">
                        <option :value="0">Neaktivovaný</option>
                        <option :value="1">Aktivovaný</option>
                        <option :value="2">Zablokovaný</option>
                    </select>
                </div>
                <div class=" mt-3">
                    <select v-model="user.rola" class="form-select">
                        <option :value="1">Admin</option>
                        <option :value="2">Company owner</option>
                        <option :value="3">Company worker</option>
                    </select>
                </div>
                <div v-if="user.rola == 3" class=" mt-3">
                    <select v-model="user.company_id" class="form-select">
                        <option 
                            v-for="company in companies" 
                            :key="company.id"
                            v-show="company.slug" 
                            :value="company.id" :selected="company.id == user.company_id">{{company.firma}}</option>
                    </select>
                </div>
                <div class=" mt-3">
                    <select v-model="user.premium" class="form-select">
                        <option :value="'free'">Zadarmo</option>
                        <option :value="'profi'">Profi</option>
                        <option :value="'small_team'">Maly tím</option>
                        <option :value="'large_team'">Veľký tím</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['editedUser','companies'],
        data() {
            return {
                created: false,
                user: {
                    email: null,
                    password: null,
                    status: 1,
                    rola: 2,
                    premium: 'free',
                    company_id: null,
                    _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                },
                emails: [],
                error: null
            }
        },
        created () {
            axios.get("/api/auth/emails").then(response => {
                response.data.forEach(element => {
                    this.emails.push(element.email)
                });
            });
        },
        methods: {   
            save() {
                if(this.created){
                    if(this.user.email == ""){
                        this.error = 'Treba zadať email.'
                        return;
                    }
                    var text = "Uživateľ bol upravený."
                    if(this.user.id == null){    
                        if(this.check_email()){
                            this.error = 'Email už existuje.'
                            return;
                        }
                        if(this.user.password == ""){
                            this.error = 'Treba zadať heslo.'
                            return;
                        }
                        text = "Uživateľ bol vytvorený."
                    }
                    axios.post("/api/users", this.user).then(response => {
                        this.$emit('addUser', true);
                        axios.get("/api/users").then(response => {
                            this.$emit('sendUsers', response.data)
                        });
                        this.$toast.success(text, {
                            timeout: 3038,
                        });
                    });
                    this.user = {
                        email: null,
                        password: null,
                        status: 1,
                        rola: 2,
                        premium: 'free',
                        _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                    }
                    this.error = null
                }
                this.created = !this.created
            },
            cancel(){
                this.created = false             
                this.user = {
                    email: null,
                    password: null,
                    status: 1,
                    rola: 2,
                    premium: 'free',
                    _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                }
                this.error = null
            },      
            check_email(){
                let hlp = false;
                this.emails.forEach(element => {
                    if(this.user.email == element){
                        hlp = true
                    }
                });
                return hlp
            },
        },  
        watch: {
            editedUser: function() {
                if(this.editedUser.id != null){
                    this.user = {
                        id: this.editedUser.id,
                        email: this.editedUser.email,
                        password: null,
                        status: this.editedUser.status,
                        rola: this.editedUser.role[0],
                        company_id: null
                    }
                    this.user['premium'] = this.editedUser.premium
                    if(this.editedUser.role[0] == 3){
                        this.companies.forEach(company => {
                            if(company.slug == this.editedUser.slug[0])
                                this.user.company_id = company.id  
                        });
                    }
                    this.created = true 
                    this.error = null
                    this.$emit('removeEdit', {});
                }
            },
            'user.rola': function(){
               if(this.user.rola != 3){
                   this.user.company_id = null
               } 
            }
        },
    }
</script>

<style lang="scss" scoped>
.buttons-users{
    @media (max-width: 766px){
        display: grid !important;
        padding: 0;
        margin: 0 !important;
    }
    .buttons{
        @media (max-width: 766px){
            order: 2;
            display: flex;
            justify-content: center;
        }
        @media (max-width: 600px){
            display: block;
            margin:0 auto;
            width:50%;
        }
        a{
             @media (max-width: 766px){
                 margin:10px;
             }
        }
    }
    .form{
        @media (max-width: 766px){
            margin:0 auto;
            width: 90%;
        }
    }
        
}
.form{
    width: 450px;
    background: white;
    padding: 22px;
    margin-left: 25px;
    margin-bottom: 50px;
}
.create{
    width: 200px;
    height: 55px;
    @media only screen and (max-width: 600px) {
        width: 95%;
    }
    margin-bottom: 20px;
    background: #2ED8B6;
    border-radius: 4px;
    font-family: Roboto;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    color: #FFFFFF;
    cursor: pointer;
    transition: .5s all;
    text-decoration: none;
    &:hover{
        background: #23caa9;
    }
}
.cancel{
    width: 200px;
    height: 55px;
    @media only screen and (max-width: 600px) {
        width: 95%;
    }
    background: #FF5370;
    border-radius: 4px;
    font-family: Roboto;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    color: #FFFFFF;
    cursor: pointer;
    transition: .5s all;
    text-decoration: none;
}
</style>